import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChartCompare: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="chart-compare"><path d="M3.75 3.75V20.25H20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M7.75 17.5V11.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M10.75 17.5V7.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M18.75 17.5V5.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M15.75 17.5V9.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconChartCompare;
